import { FC, useEffect, useState } from "react";
import { adsData } from "../core/_requests";

type Props = {
  clientData: any;
  generalSettings: any;
  adSlot: any;
};

const AdComponent: FC<Props> = ({ clientData, generalSettings, adSlot }) => {
  const [adData, setAdData]: any = useState<any>();

  useEffect(() => {
    adsData(clientData.clients_id).then((response) => {
      setAdData(response.data);
    });

    installGoogleAds();
  }, []);

  useEffect(() => {
    const pushAd = () => {
      try {
        const adsbygoogle = window.adsbygoogle;
        adsbygoogle.push({});
      } catch (e) {
        console.error(e);
      }
    };

    let interval = setInterval(() => {
      // Check if Adsense script is loaded every 300ms
      if (window.adsbygoogle) {
        pushAd();
        // clear the interval once the ad is pushed so that function isn't called indefinitely
        clearInterval(interval);
      }
    }, 300);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const installGoogleAds = () => {
    const elem = document.createElement("script");
    elem.src =
      "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5837481348036196";
    elem.async = true;
    elem.defer = true;
    document.body.insertBefore(elem, document.body.firstChild);
  };

  return (
    <>
      <div className="max-h-[90px] relative w-full text-center">
        <ins
          className="adsbygoogle"
          style={{
            display: "block",
            width: "100%",
            height: "90px",
          }}
          data-ad-client="ca-pub-5837481348036196"
          data-ad-slot={adSlot}
          data-full-width-responsive="false"
        ></ins>
      </div>
    </>
  );
};
export default AdComponent;
